import React from 'react';
import {
    IonButton, IonItem, IonInput,
    IonIcon,
} from '@ionic/react';
import { connect } from 'react-redux';

import { withTranslation } from '../../lib/translate';

import './index.css';
import Basket from '../../lib/basket';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../common';
import { closeOutline } from 'ionicons/icons';
import { forwardTo, makeKey } from '../../lib/utils';
import Incrementer from '../incrementer';
import { getConfig } from '../../appConfig';
import { setCommonModal } from '../../store/actions';

// limited stock can be on the item itself or on a selected variation/modifier (Square multi-variation items)
const basketItemHasSku = (basketItem, sku) =>
    basketItem.item.sku == sku ||
    (basketItem.selectedChoices || []).some(group => (group || []).some(choice => choice.sku == sku));

class InsuficientStock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }

    formatData = (item) => {
        if (Basket.has_multi_basket) {
            const group = Basket.multi_basket_items.find(g => g.restaurant.id == item.restaurantId);
            if (!group) return [];
            return group.items
                .map((basketItem, index) => ({ ...basketItem, _restaurantId: item.restaurantId, _basketIndex: index }))
                .filter(el => basketItemHasSku(el, item.sku));
        }
        return Basket.items.filter(el => basketItemHasSku(el, item.sku));
    }

    drawSubItemsText = (basketItem = {} /*, basketItemIndex*/) => {
        const { selectedChoices } = basketItem;
        const basketInstance = this.props.basketInstance || Basket;
        const { profile } = this.props;
        if (selectedChoices && selectedChoices.length > 0) {
            return selectedChoices.map((choiceGroup, choiceGroupIndex) => {
                return (choiceGroup || []).map((choice, choiceIndex) => {
                    const { sku } = choice;
                    return (
                        <div className={choice.bundleModifier ? 'sub-item modifier-item bundle-modifier-item' : 'sub-item modifier-item'} key={makeKey(choiceGroupIndex, choiceIndex, sku)} /*onClick={ () => this.handleOrderItemClick(basketItem, basketItemIndex) }*/>
                            <NormalText className="paddLR grow">
                                <SmallText>
                                    {choice.quantity} x {Basket.getProductName(choice, profile)}
                                </SmallText>
                            </NormalText>
                            <NormalText className="righted paddLR self-aligned">
                                <SmallText className='label-color'>{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0 ? basketInstance._calculateSubItemPrice(choice, choice.quantity) : null}</SmallText>
                            </NormalText>
                        </div>
                    );
                });
            });
        }
        return null;
    };

    isBasketValid = () => {
        const allItems = Basket.has_multi_basket
            ? Basket.multi_basket_items.flatMap(g => g.items)
            : Basket.items;
        const basketMap = allItems.reduce((acc, entry) => {
            const sku = entry.item.sku;
            const qty = entry.quantity || 0;
            acc[sku] = (acc[sku] || 0) + qty;
            // same count as the backend: choice quantity x item quantity
            (entry.selectedChoices || []).forEach(group => (group || []).forEach(choice => {
                acc[choice.sku] = (acc[choice.sku] || 0) + (choice.quantity || 1) * qty;
            }));
            return acc;
        }, {});
        return Basket.getInsuficientStockData().some(beItem => {
            const basketQty = basketMap[beItem.sku] || 0;
            return basketQty > beItem.quantity;
        });
    };

    changeQuantity = (item, quantity) => {
        if (Basket.has_multi_basket) {
            Basket.changeItemQuantity(item._basketIndex, quantity, false, item._restaurantId);
        } else {
            Basket.changeItemQuantity(Basket.items.indexOf(item), quantity, false);
        }
    }

    renderStockItem = (el) => {
        const { __, profile } = this.props;
        const basketItems = this.formatData(el);
        if (basketItems.length === 0) return null;
        return (
            <React.Fragment key={`${el.restaurantId}-${el.sku}`}>
                <div className='insuficient-stock-modal'>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '15px', alignItems: 'flex-end' }}>
                        <StrongText>{el.name}</StrongText>
                        <SmallText>{`${__('Requested')}: ${el.requested} / ${__('Available')} ${el.quantity}`}</SmallText>
                    </div>

                    <div className='basket-items-wrapper'>
                        {basketItems.map(basketItem => {
                            const { quantity, item, instructions } = basketItem;
                            let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
                            if (image && image.indexOf('http://') !== -1) {
                                image = image.replace(/http:\/\//g, 'https://');
                            }

                            return <div className='box-content'>
                                {!getConfig().flags.removeMenuImages &&
                                    <div
                                        className="order-item-image"
                                        style={
                                            image && image !== ''
                                                ? { backgroundImage: `url(${image})` }
                                                : {
                                                    backgroundSize: 'contain',
                                                    backgroundImage: `url(${Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image})`,
                                                }
                                        }
                                    />}
                                <div className="item-content-wrapper flex-justify-between flex-row-wrapper">
                                    <div>
                                        <div style={{ display: 'grid', gridAutoFlow: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
                                            <StrongText className="block text-to-update">{Basket.getProductName(item, profile)}</StrongText>

                                            <IonIcon className='pointer' icon={closeOutline} onClick={() => { this.changeQuantity(basketItem, 0) }} />
                                        </div>


                                        {this.drawSubItemsText(basketItem)}
                                        {instructions && instructions !== '' && (
                                            <>
                                                <Spacer size={2} />
                                                <SmallText className="block">{`${__('Instructions')}: ${instructions}`} </SmallText>
                                            </>
                                        )}
                                    </div>

                                    <div className="item-content-actions flex-justify-between flex-col-wrapper flex-align-center">
                                        <Incrementer
                                            onUpdate={(val) => {
                                                this.changeQuantity(basketItem, val)
                                            }}
                                            quantity={quantity}
                                            step={1}
                                            allowNegative={false}
                                            minLimit={1}
                                        >
                                            <StrongText className="bold primary-color">{quantity}</StrongText>
                                        </Incrementer>
                                        <StrongText>
                                            {Basket.formatPrice(Basket.calculateItemPrice(basketItem, false))}
                                        </StrongText>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
                <Spacer size={5} />
            </React.Fragment>
        );
    }

    render() {
        const { __, } = this.props;
        const items = Basket.getInsuficientStockData();

        const restaurantGroups = Basket.has_multi_basket
            ? Object.values(items.reduce((groups, item) => {
                const key = item.restaurantId;
                if (!groups[key]) groups[key] = { restaurantId: key, restaurantName: item.restaurantName, items: [] };
                groups[key].items.push(item);
                return groups;
            }, {}))
            : null;

        return (
            <div>
                <Title className='modal-title'>{__('Insuficient stock')}</Title>
                <Spacer size={2} />
                <StrongText>{__("Some items in your basket have limited stock and your requested quantity exceeds what's available. Please update your order.")}</StrongText>
                <Spacer size={5} />
                {Basket.has_multi_basket ? <>
                    {restaurantGroups.map(group => (
                        <div key={group.restaurantId}>
                            <StrongText className="block">{group.restaurantName}</StrongText>
                            <Spacer size={2} />
                            {group.items.map(el => this.renderStockItem(el))}
                        </div>
                    ))}
                </> : <>
                    {items.map(el => this.renderStockItem(el))}
                </>}
                <IonButton onClick={() => {Basket.setInsuficientStockData([]);this.props.dispatch(setCommonModal('insuficientStockModalOpened', false));forwardTo('/order-summary')}} expand='block' disabled={this.isBasketValid()}>{__('Continue')}</IonButton>
            </div>
        );
    }
}

const stateToProps = (state) => {
    return {
        profile: state.profile.profile || [],
        clientProfile: state.common.clientProfile,
        basketUpdated: state.orders.basketUpdated
    };
};

export default connect(stateToProps)(withTranslation(InsuficientStock));
